import React, { useEffect } from 'react';
import $ from 'jquery'; // Import jQuery
import './startselling.css'
import Headertop from '../../components/Headertop';
import Header from '../../components/Header';
import Servicestopbar from '../../components/Servicestopbar';
import Footer from '../../components/Footer';

function StartSelling() {
  useEffect(() => {
    $(document).ready(function () {
      var current_fs, next_fs, previous_fs; // fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;

      setProgressBar(current);

      $(".next").click(function () {
        current_fs = $(this).parent();
        next_fs = $(this).parent().next();

        // Add Class Active
        $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

        // Show the next fieldset
        next_fs.show();
        // Hide the current fieldset with style
        current_fs.animate(
          { opacity: 0 },
          {
            step: function (now) {
              // For making fieldset appear animation
              opacity = 1 - now;

              current_fs.css({
                display: 'none',
                position: 'relative',
              });
              next_fs.css({ opacity: opacity });
            },
            duration: 500,
          }
        );
        setProgressBar(++current);
      });

      $(".previous").click(function () {
        current_fs = $(this).parent();
        previous_fs = $(this).parent().prev();

        // Remove class active
        $("#progressbar li")
          .eq($("fieldset").index(current_fs))
          .removeClass("active");

        // Show the previous fieldset
        previous_fs.show();

        // Hide the current fieldset with style
        current_fs.animate(
          { opacity: 0 },
          {
            step: function (now) {
              // For making fieldset appear animation
              opacity = 1 - now;

              current_fs.css({
                display: 'none',
                position: 'relative',
              });
              previous_fs.css({ opacity: opacity });
            },
            duration: 500,
          }
        );
        setProgressBar(--current);
      });

      function setProgressBar(curStep) {
        var percent = parseFloat((100 / steps) * curStep);
        percent = percent.toFixed();
        $(".progress-bar").css('width', percent + '%');
      }

      $(".submit").click(function () {
        return false;
      });
    });
  }, []); // The empty dependency array ensures that this effect runs once after the initial render

  return (
    <div className="container-fluid">
      <Headertop />
      <Header />
      <Servicestopbar />
      <div className="row justify-content-center">
        <div className="col-11 col-sm-9 col-md-7 col-lg-6 col-xl-5 text-center p-0 mt-3 mb-2">
          <div className="card px-0 pt-4 pb-0 mt-3 mb-3">
            <h2 id="heading">Sign Up Your User Account</h2>
            <p>Fill all form fields to go to the next step</p>

            <form id="msform">
              {/* progressbar */}
              <ul id="progressbar">
                <li className="active" id="account"><strong>Account Information</strong></li>
                <li id="personal"><strong>Personal Information</strong></li>
                <li id="payment"><strong>Service Information</strong></li>
                <li id="confirm"><strong>Finish</strong></li>
              </ul>
              <div className="progress">
                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
              <br />
              {/* fieldsets */}
              <fieldset>
                <div className="form-card">
                  <div className="row">
                    <div className="col-7">
                      <h2 className="fs-title">Account Information:</h2>
                    </div>
                    <div className="col-5">
                      <h2 className="steps">Step 1 - 4</h2>
                    </div>
                  </div>
                  <label className="fieldlabels">Email: *</label>
                  <input type="email" name="email" placeholder="Email Id" />
                  <label className="fieldlabels">Username: *</label>
                  <input type="text" name="uname" placeholder="UserName" />
                  <label className="fieldlabels">Password: *</label>
                  <input type="password" name="pwd" placeholder="Password" />
                  {/* <label className="fieldlabels">Confirm Password: *</label>
                  <input type="password" name="cpwd" placeholder="Confirm Password" /> */}
                </div>
                <input type="button" name="next" className="next action-button" value="Next" />
              </fieldset>
              <fieldset>
                <div className="form-card">
                  <div className="row">
                    <div className="col-7">
                      <h2 className="fs-title">Personal Information:</h2>
                    </div>
                    <div className="col-5">
                      <h2 className="steps">Step 2 - 4</h2>
                    </div>
                  </div>
                  <label className="fieldlabels">First Name: *</label>
                  <input type="text" name="fname" placeholder="First Name" />
                  <label className="fieldlabels">Last Name: *</label>
                  <input type="text" name="lname" placeholder="Last Name" />
                  <label className="fieldlabels">Contact No.: *</label>
                  <input type="text" name="phno" placeholder="Contact No." />
                  <label className="fieldlabels">Education: *</label>
                  <input type="text" name="edu" placeholder="Education" />
                  <label className="fieldlabels">Country: *</label>
                  <input type="text" name="country" placeholder="Country" />
                </div>
                <input type="button" name="next" className="next action-button" value="Next" />
                <input type="button" name="previous" className="previous action-button-previous" value="Previous" />
              </fieldset>
              <fieldset>
                <div className="form-card">
                  <div className="row">
                    <div className="col-7">
                      <h2 className="fs-title">Service Information:</h2>
                    </div>
                    <div className="col-5">
                      <h2 className="steps">Step 3 - 4</h2>
                    </div>
                  </div>
                  <label className="fieldlabels">Field: *</label>
                  <input type="text" name="Field" placeholder="Field" />
                  <label className="fieldlabels">Fees: *</label>
                  <input type="number" name="fees" placeholder="write your fees here($)" />
                  <label className="fieldlabels">Portfolio: *</label>
                  <input type="text" name="Portfolio" placeholder="Write your Portfolio here" />
                  <label className="fieldlabels">Upload Your Resume:</label>
                  <input type="file" name="pic" accept="image/*" />
                  {/* <label className="fieldlabels">Upload Signature Photo:</label>
                  <input type="file" name="pic" accept="image/*" /> */}
                </div>
                <input type="button" name="next" className="next action-button" value="Submit" />
                <input type="button" name="previous" className="previous action-button-previous" value="Previous" />
              </fieldset>
              <fieldset>
                <div className="form-card">
                  <div className="row">
                    <div className="col-7">
                      <h2 className="fs-title">Finish:</h2>
                    </div>
                    <div className="col-5">
                      <h2 className="steps">Step 4 - 4</h2>
                    </div>
                  </div>
                  <br /><br />
                  <h2 className="purple-text text-center"><strong>SUCCESS !</strong></h2>
                  <br />
                  <div className="row justify-content-center">
                    <div className="col-3">
                      <img src="https://i.imgur.com/GwStPmg.png" alt="Success" className="fit-image" />
                    </div>
                  </div>
                  <br /><br />
                  <div className="row justify-content-center">
                    <div className="col-7 text-center">
                      <h5 className="purple-text text-center">You Have Successfully Signed Up</h5>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default StartSelling;
